
import MainContent from "../components/MainContent";
import { CompanyLogo, LoginBackground } from '../assets/imgs';
import { Box, Button, TextField, Avatar, Link } from '@mui/material';
import { useLocation, useNavigate } from "react-router-dom";
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import { GlobalStateContext } from '../store/GlobalState';
// import { useLazyGetAuthDetailsQuery } from '../features/auth/authApiSlice';
import { useDispatch } from 'react-redux';
import { useRef, useState, useEffect, useMemo, useContext } from 'react'
import { setCredentials } from '../features/auth/authSlice'
import { useLoginGlobalAccountMutation, useLoginMutation } from '../features/auth/authApiSlice'

const Login = () => {
    const [showAlert, setShowAlert] = useState(false);
    const [showPWAlert, setShowPWAlert] = useState(false);
    const [showWarningAlert, setShowWarningAlert] = useState(false);
    const globalState = useContext(GlobalStateContext)
    const userRef = useRef<HTMLInputElement>(null);
    const [user, setUser] = useState('')
    const [pwd, setPwd] = useState('')
    const [errMsg, setErrMsg] = useState('')
    const navigate = useNavigate()

    const [login] = useLoginMutation()
    const [loginGlobalAccount] = useLoginGlobalAccountMutation()
    const dispatch = useDispatch()

    useEffect(() => {
        if (globalState.token) {
            dispatch(setCredentials({ accessToken: globalState.token, user }))
            localStorage.setItem('token', globalState.token)
            // setLogin(true);
            navigate("/Main");
            return; // not needed to fetch data
        }
        userRef.current?.focus()
    }, [])

    useEffect(() => {
        setErrMsg('')
    }, [user, pwd])

    const handleSubmit = async (e: any) => {
        e.preventDefault()

        try {
            var userData;
            if (user == 'castco' && pwd == 'castco12345@work') {
                userData = await loginGlobalAccount({ user, pwd }).unwrap()
            }
            else {
                userData = await login({ user, pwd }).unwrap()
            }
            dispatch(setCredentials({ accessToken: userData, user }))
            setUser('')
            setPwd('')
            localStorage.setItem('token', userData)
            globalState.setToken(userData)
            // setLogin(true);
            navigate('/main')
        } catch (err) {
            if (err.status === 400) {
                setShowWarningAlert(true)
                setErrMsg('Unauthorized');
            } else if (err.status === 404) {
                setShowPWAlert(true)
                setErrMsg('Missing Username or Password');
            } else {
                setShowAlert(true)
                setErrMsg('Login Failed');
            }
            console.log(errMsg);
            // setLogin(false);
        }
    }

    const handleUserInput = (e: any) => setUser(e.target.value)

    const handlePwdInput = (e: any) => setPwd(e.target.value)

    const containerStyle = {
        backgroundImage: `url(${LoginBackground})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
    };

    const logoContainerStyle = {
        width: '150px',
        height: '150px',
        borderRadius: '50%',
        backgroundColor: 'white',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        marginBottom: '-40px',
    };

    const logoStyle = {
        width: '80%',
        height: 'auto',
    };

    const formContainerStyle = {
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        p: 3,
        borderRadius: 4,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    };

    const buttonStyle = {
        backgroundColor: '#94D1E0',
        color: 'white',
    };

    return (
        <MainContent>
            <Box sx={containerStyle}>
                <Box sx={logoContainerStyle}>
                    <img src={CompanyLogo} alt="Logo" style={logoStyle} />
                </Box>
                <form onSubmit={handleSubmit}>
                    <Box sx={formContainerStyle}>
                        <h2 >Concrete Cube Lab</h2>
                        <TextField label="Username" type="text" value={user} ref={userRef} id="username" onChange={handleUserInput} required />
                        <TextField label="Password" type="password" id="password" value={pwd} onChange={handlePwdInput} required />
                        <Link href="#" sx={{ alignSelf: 'flex-end', mt: 1, mb: 1 }}>
                            Forgot Password?
                        </Link>
                        {showAlert && (
                            <Alert sx={{ mb: 1 }} variant="filled" severity="error" onClose={() => setShowAlert(false)}>
                                Login Failed. <br /> Please contact your administrator.
                            </Alert>

                        )}
                        {showPWAlert && (
                            <Alert sx={{ mb: 1 }} variant="filled" severity="error" onClose={() => setShowPWAlert(false)}>
                                Username or password does not match.
                            </Alert>

                        )}
                        {showWarningAlert && (
                            <Alert sx={{ mb: 1 }} variant="filled" severity="warning" onClose={() => setShowWarningAlert(false)}>
                                The account is not authorized to log in from this station. <br /> Please contact your administrator.
                            </Alert>

                        )}
                        <Button variant="contained" type="submit" sx={buttonStyle}>Login</Button>
                    </Box>
                </form>
            </Box>
        </MainContent>
    );
}
export default Login;